<template>
  <div id="FanList" class="page product-list">
    <rate-feedback
        v-if="feedbackDialogVisible"
        :code="gjwCategoryCode"
        title="通风机"
        type="7"
        @close="closeFeedbackDialog" />
    <div class="search-box">
      <div class="search-block curve-block border-bottom-divide">
        <span class="label">性能</span>
        <gjw-switch
          class="switch"
          v-model="isSingleSpeed"
          :has-text="true"
          active-text="单速"
          in-active-text="双速"
          :width="50"
          @change="onSpeedChanged"
         />
         <curve-search
          ref="curveSearch"
          class="curve"
          :speed-control="isSingleSpeed ? 'SINGLE_SPEED' : 'DOUBLE_SPEED'"
          :curve-form-items="curveFormItems"
          @curve-search="searchByCurve" />
      </div>
      <div class="search-block border-bottom-divide">
        <span class="label">品牌</span>
        <div class="brand-content">
          <span
              v-for="item in brands"
              :key="item.brandCode"
              class="brand-tag"
              :class="{'active': selectBrand === item.brandCode, 'disabled': item.disabled}"
              @click="clickBrand(item)"
          >
            {{item.brandName}}
          </span>
        </div>
      </div>
      <div class="search-block border-bottom-divide">
        <span class="label keyword-label">筛选</span>
        <filter-search ref="filterSearch" :search-properties="searchProperties" @select="onFilterSelected" @change="handleShowFilterSearch" />
      </div>
    </div>
    <div class="result-row">
      <filter-result
        :speed-control="isSingleSpeed ? 'SINGLE_SPEED' : 'DOUBLE_SPEED'"
        :gjw-category-code = "gjwCategoryCode"
        :curve-properties="curveProperties"
        :product-properties="productProperties"
        :total-count="totalCount"
        @clear-curve-filter="clearCurveFilter"
        @clear-product-filter="clearProductFilter"
        @clear-deviation-filter="clearDeviationFilter"
        @clear-all-filters="clearAllFilters" />
    </div>
    <gjw-dimensions @height-changed="getTableBoxHeight">
      <div ref="tableBox" class="table-box">
        <el-table
            ref="fanTable"
            v-show="showTable"
            class="row-click-table"
            v-loading="productsLoading"
            :data="tableData"
            :max-height="tableHeight"
            style="width:100%;"
            @sort-change="onSortChange"
            @row-click="(row)=>toDetail(row)"
        >
          <el-table-column label="产品型号" prop="model" min-width="180px" fixed>
            <template v-slot="scope">
              <product-model-col :row="scope.row" @image-click="toDetail" @model-click="toDetail" />
            </template>
          </el-table-column>
          <el-table-column label="风量(m³/h)" prop="wind" :formatter="fmtValue" min-width="64px" sortable="custom"/>
          <el-table-column
              v-if="searchWithCurveProperties"
              label="风量偏差率(%)"
              min-width="64px"
          >
            <template v-slot="scope">
              <deviation-value :row="scope.row" relate-prop="wind"/>
            </template>
          </el-table-column>
          <el-table-column label="全压(Pa)" prop="pressure" :formatter="fmtValue"  min-width="64px" sortable="custom" />
          <el-table-column
              v-if="searchWithCurveProperties && !isOnlyQueryWind"
              label="全压偏差率(%)"
              min-width="64px"
          >
            <template v-slot="scope">
              <deviation-value :row="scope.row" relate-prop="pressure"/>
            </template>
          </el-table-column>
          <el-table-column label="电机功率(kW)" prop="power" :formatter="fmtValue" min-width="64px" sortable="custom" />
          <el-table-column label="全压效率(%)" prop="efficiency" :formatter="fmtValue" min-width="64px" sortable="custom" />
          <el-table-column
            v-if="showAirVolume"
            label="单位风量耗功率 (W/(m³/h))"
            prop="powerConsumptionPerAirVolume"
            :formatter="fmtValue"
            min-width="80px">
            <template #header>
              <div class="flex-container flex-row flex-verti-center">
                <div>单位风量耗功率 (W/(m³/h))</div>
                <el-tooltip effect="dark" placement="top-start" content="=设计全压/(3600*0.855*运行全压效率/100)">
                  <i class="icon-hover gjw-iconfont gjw-icon-tishi1"></i>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
<!--          <el-table-column label="噪声(dB(A))" prop="noise" :formatter="fmtValue" min-width="60px" sortable="custom" />-->
          <el-table-column label="转速(rpm)" prop="speed" :formatter="fmtValue" min-width="60px"/>
<!--          <el-table-column label="长度(mm)" prop="length" min-width="60px" />-->
<!--          <el-table-column label="宽度(mm)" prop="width" min-width="60px" />-->
<!--          <el-table-column label="高度(mm)" prop="height" min-width="60px" />-->
<!--          <el-table-column label="设备重量(kg)" prop="weight" min-width="60px" />-->
          <el-table-column label="操作" width="112px" fixed="right">
            <template v-slot="scope">
              <!-- <el-button plain class="table-button sub-primary" @click.stop="toSelected(scope.row, scope.$index)" :disabled="selectingIndex === scope.$index">选中</el-button> -->
              <el-tooltip v-if="showPlaceComp && !isFromEntrance" content="布置该产品构件" placement="top">
                <el-button plain class="table-button main-primary" @click.stop="toPlaceComponent(scope.row)">布置</el-button>
              </el-tooltip>
              <el-tooltip v-if="showPlaceCompG && !isFromEntrance" content="载入该产品构件" placement="top">
                  <el-button plain class="table-button main-primary" @click.stop="toLoadGcsComp(scope.row)">载入</el-button>
              </el-tooltip>
              <el-tooltip v-if="isFromEntrance" content="选中该产品构件" placement="top">
                  <el-button plain class="table-button main-primary" @click.stop="selectGcsComp(scope.row)">选中</el-button>
              </el-tooltip>
              <el-popover
                  v-if="showPlaceCompWeb"
                  popper-class="no-padding-popper"
                  placement="bottom-end"
                  width="300"
                  trigger="hover"
                  @show="showPopover(scope.row)">
                <source-list-popover :loading="resourceLoading" :resource="scope.row.resource" @handleClick="toDetail(scope.row)"/>
                <template #reference>
                  <el-button type="primary" plain class="table-button main-primary pop-button" @click.stop="toDetail(scope.row)">下载</el-button>
                </template>
              </el-popover>
            </template>
          </el-table-column>
          <template #empty>
            <span v-if="selectedBrandUrl">非常抱歉，由于产品数据较少，未查询到符合条件的产品，您可以<em class="empty-list-feedback" @click="toFeedback">联系厂家</em>，留下产品需求和联系方式，厂家收到需求后会与您联系</span>
            <span v-else>非常抱歉，由于产品数据较少，未查询到符合条件的产品，您可以填写<em class="empty-list-feedback" @click="toFeedback">反馈</em>，让我们帮您找到合适的产品</span>
          </template>
          <template #append>
            <div v-if="showUnsatisfiedInfo" class="feedback-info">
              <span v-if="selectedBrandUrl">以上结果都不满足您的选型需求？您可以<em class="empty-list-feedback" @click="toFeedback">联系厂家</em>，留下产品需求和联系方式，厂家收到需求后会与您联系</span>
              <span v-else>对选型结果不满意？您可以填写<em class="empty-list-feedback" @click="toFeedback">反馈</em>，让我们帮您找到合适的产品</span>
            </div>
          </template>
        </el-table>
        <el-pagination
            small
            style="text-align: right; margin-top: 4px;"
            @current-change="currentChange"
            :current-page="pageNo"
            :page-size="pageSize"
            layout="prev, pager, next"
            :total="totalCount">
        </el-pagination>
      </div>
    </gjw-dimensions>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import envCodes from '@/assets/js/envCodes'
import checkLoginMixin from '@/mixins/checkLoginMixin'
import productListMixin from '@/mixins/productListMixin'
import productDetailMixin from '@/mixins/productDetailMixin'
import GjwDimensions from '@/components/lib/GjwDimensions'
import SourceListPopover from './components/SourceListPopover'
import DeviationValue from './components/DeviationValue.vue'
import GjwSwitch from '@/components/lib/GjwSwitch.vue'
import RateFeedback from './components/RateFeedback.vue'
import CurveSearch from '@/views/products/components/CurveSearch'
import FilterSearch from '@/views/products/components/FilterSearch'
import FilterResult from '@/views/products/components/FilterResult'
import ProductModelCol from '@/views/products/components/ProductModelCol'
import defaultViewMixin from '@/mixins/defaultViewMixin'
import ProductStrategy from '@/views/products/strategy/ProductStrategy'
export default {
  name: 'FanList',
  components: { GjwDimensions, SourceListPopover, DeviationValue, GjwSwitch, CurveSearch, FilterSearch, FilterResult, ProductModelCol, RateFeedback },
  mixins: [checkLoginMixin, productListMixin, defaultViewMixin, productDetailMixin],
  data() {
    return {
      gjwCategoryCode: envCodes.fanCode,
      selectBrand: null,
      isSingleSpeed: true,
      curveProperties: [],
      productProperties: [],
      productSeriesId: null,
      productSeriesName: null,
      pageNo: 1,
      pageSize: 20,
      tableBox: null,
      tableHeight: 0,
      selectingIndex: -1,
      orderProp: null, // 属性对应的列名
      orderBy: null, // 属性code或者产品系列
      orderType: null,
      showFilterSearch: false,
      showTable: true, // 在展示耗功率的时候会出现样式错乱，通过v-show（display）控制表格展示来解决
      feedbackDialogVisible: false,
    }
  },
  computed: {
    ...mapGetters({
      user: 'user/user',
      brands: 'fanList/brands',
      tableData: 'fanList/tableData',
      totalCount: 'fanList/totalCount',
      productsLoading: 'fanList/productsLoading',
      searchProperties: 'fanList/searchProperties',
      existFeedbackVisit: 'fanList/existFeedbackVisit',
      // 由选型首页带过来的搜索条件
      currentBrands: 'fastSearch/currentBrands',
      speedValue: 'fastSearch/speedValue',
      curveSearchValues: 'fastSearch/curveSearchValues',
      propertySearchValues: 'fastSearch/propertySearchValues',
      isFromEntrance: 'isFromEntrance',
    }),
    curveFormItems() {
      const speed = this.isSingleSpeed ? 'SINGLE_SPEED' : 'DOUBLE_SPEED'
      return ProductStrategy.getCurveFormItems(this.gjwCategoryCode, speed)
    },
    showUnsatisfiedInfo() {
      return this.tableData.length && this.tableData.length < 5
    },
    // 是否只是单搜风量
    isOnlyQueryWind() {
      if (this.searchWithCurveProperties) {
        const hasQueried = this.curveProperties.filter((c) => c.value || c.value === 0)
        if (hasQueried.length) {
          if (this.isSingleSpeed) {
            return hasQueried.length === 1 && hasQueried[0].label === '风量'
          }
          // 高速风量和低速全压认为是只搜风量
          return hasQueried.length === 1 ? hasQueried[0].label === '高速风量' : hasQueried.length === 2 && hasQueried.some((q) => q.label === '低速全压' || q.label === '低速风量')
        }
      }
      return false
    },
    showAirVolume() {
      return this.isSingleSpeed && this.searchWithCurveProperties && !this.isOnlyQueryWind
    },
    selectedBrandUrl() {
      if (this.selectBrand) {
        const selectBrandItem = this.brands.find((item) => item.brandCode === this.selectBrand) || {}
        return selectBrandItem.brandUrl
      }
      return null
    }
  },
  watch: {
    showAirVolume() {
      this.showTable = false
      setTimeout(() => {
        this.showTable = true
      }, 300)
    }
  },
  created() {
    this.loadBrands({ gjwCategoryCode: this.gjwCategoryCode })
    this.selectBrand = this.currentBrands
    this.isSingleSpeed = this.speedValue === 'SINGLE_SPEED'
    this.curveProperties = [...this.curveSearchValues]
    this.productProperties = [...this.propertySearchValues]
    this.getList()
    if (this.platform === 'r') {
      this.loadDefinitions({ gjw_category_code: this.gjwCategoryCode })
    }
  },
  methods: {
    ...mapMutations({
      setShopAnimation: 'setShowShopAnimation'
    }),
    ...mapActions({
      loadUserInfo: 'user/loadUserInfo',
      loadBrands: 'fanList/loadBrands',
      loadAggBrands: 'fanList/loadAggBrands',
      loadAggProperties: 'fanList/loadAggProperties',
      loadProducts: 'fanList/loadProducts',
      loadExistFeedbackVisit: 'fanList/existFeedbackVisit',
    }),
    // 根据单双速，处理值的显示
    fmtValue(row, col) {
      const colProp = col.property
      if (row.speedControl === 'SINGLE_SPEED') {
        return this.$fmtValue(row[colProp], '-')
      } else if (row.speedControl === 'DOUBLE_SPEED') {
        const highValue = row[`${colProp}High`]
        const lowValue = row[`${colProp}Low`]
        if (highValue || lowValue) {
          return `${this.$fmtValue(highValue, '-')} / ${this.$fmtValue(lowValue, '-')}`
        }
        return '- / -'
      }
    },
    getTableBoxHeight(obj) {
      const height = obj.newValue - 30 > 0 ? obj.newValue - 30 : 30
      this.tableHeight = height.toFixed(0)
    },
    clickBrand(brand) {
      if (brand.disabled) { return }
      this.selectBrand = this.selectBrand === brand.brandCode ? null : brand.brandCode
      this.search()
    },
    closeFeedbackDialog() {
      this.feedbackDialogVisible = false
    },
    /**
     * 获取产品列表和聚合属性列表
     * @param options: 对象，其中 refreshOrder 是否处理排序 默认需要处理；refreshProperty 是否刷新属性列表 默认需要处理
     */
    getList(options = { refreshOrder: true, refreshProperty: true }) {
      const { refreshOrder, refreshProperty } = options
      refreshOrder && this.updateOrderBy()
      const curveProperties = this.searchWithCurveProperties ? this.curveProperties.map((c) => {
        return {
          code: c.code,
          value: c.value,
          deviationRate: c.deviationRate
        }
      }) : null
      // if(!this.productProperties)
      let productProperties = this.productProperties.reduce((arr, p) => {
        if (p.code === 'productSeries') {
          this.productSeriesId = p.valueCode
          this.productSeriesName = p.valueName
        } else if (arr.some((s) => s.code === p.code)) {
          arr.find((f) => f.code === p.code).values.push(p.valueCode)
        } else {
          arr.push({
            code: p.code,
            parameterType: p.parameterType,
            queryType: p.queryType,
            values: [p.valueCode]
          })
        }
        return arr
      }, [])
      productProperties = productProperties.length ? productProperties : null
      if (productProperties) {
        productProperties = productProperties.filter((f) => f.code)
      }
      const params = {
        gjwCategoryCode: this.gjwCategoryCode,
        brandCode: this.selectBrand || null,
        productSeriesId: this.productSeriesId || null,
        productSeriesName: this.productSeriesName || null,
        speedControl: this.isSingleSpeed ? 'SINGLE_SPEED' : 'DOUBLE_SPEED' || null,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        curveProperties,
        productProperties,
        orderBy: this.orderBy,
        orderType: this.orderType
      }
      this.loadProducts(params).then(() => {
        this.searchTrack(params)
        if (refreshProperty) {
          // 重新聚合筛选条件
          const paramsForBrand = {
            gjwCategoryCode: this.gjwCategoryCode,
            // productSeriesId: this.productSeriesId || null,
            speedControl: this.isSingleSpeed ? 'SINGLE_SPEED' : 'DOUBLE_SPEED' || null,
            // curveProperties,
            // productProperties,
          }
          this.loadAggBrands(paramsForBrand)
          const paramsForProperties = {
            ...paramsForBrand,
            // brandCode: this.selectBrand || null,
          }
          // 筛选条件取消聚合
          if (localStorage.getItem('isSelect') !== '1') {
            this.loadAggProperties(paramsForProperties)
            this.loadAggProductSeries(paramsForProperties)
          }
        }
        const isNotDefaultSearchCondition = !!(this.selectBrand || this.productSeriesId || curveProperties || productProperties)
        if (isNotDefaultSearchCondition) {
          this.loadExistFeedbackVisit({ classification_code: this.gjwCategoryCode }).then(() => {
            if (!this.existFeedbackVisit) {
              setTimeout(() => {
                this.feedbackDialogVisible = true
              }, 2000)
            }
          })
        }
      })
    },
    search() {
      this.pageNo = 1
      this.getList()
    },
    // 开始查找
    searchByCurve(curveProperties) {
      this.curveProperties = curveProperties
      this.search()
    },
    currentChange(val) {
      this.pageNo = val
      this.getList({ refreshOrder: false, refreshProperty: false })
    },

    // 选中项目
    async toSelected(row, index) {
      try {
        this.selectingIndex = index
        this.setShopAnimation(false)
        // 判断是否登录 & 获取当前项目
        const res = await this.checkLogin()
        if (res) {
          const designProperties = this.getDesignProperties(row, true)
          const runtimeProperties = this.getRunTimeProperties(row, true)
          const payload = {
            productId: row.id,
            designProperties,
            runtimeProperties
          }
          await this.handleSelectProduct(payload)
          this.$nextTick(() => {
            this.setShopAnimation(true)
          })
          this.selectTrack({
            productId: row.id,
            gjwCategoryCode: envCodes.fanCode,
            gjwCategoryName: '通风机',
            source: 'products'
          })
        }
      } catch (err) {
        console.log(err)
      } finally {
        this.selectingIndex = -1
      }
    },
    /**
     * 选中、查看的设计点值整理：
     * 选中的设计点 若为空需要处理成'-'，因为在已选列表页面需要这么展示
     * 查看的设计点 若为空处理成'null'，因为详情接口接收的是null，在详情页展示的时候再转换成‘-’
    */
    getDesignProperties(row, isToSelect = false) {
      const emptyValue = isToSelect ? '-' : null
      const values = {}
      const isSingleSpeed = this.isSingleSpeed
      let designValue1 = null
      let designValue2 = null
      this.curveProperties.forEach((item) => {
        values[item.code] = item.value
      })
      designValue1 = isSingleSpeed ? values[envCodes.wind] || emptyValue : this.getRowDoubleSearch(row, values, 'wind', emptyValue)
      designValue2 = isSingleSpeed ? values[envCodes.pressure] || emptyValue : this.getRowDoubleSearch(row, values, 'pressure', emptyValue)
      return [
        {
          codes: isSingleSpeed ? envCodes.wind : `${envCodes.windHigh}/${envCodes.windLow}`,
          name: '设计风量',
          sort: 1,
          unit: 'm³/h',
          type: 'design',
          values: designValue1
        }, {
          codes: isSingleSpeed ? envCodes.pressure : `${envCodes.pressureHigh}/${envCodes.pressureLow}`,
          name: '设计全压',
          sort: 2,
          unit: 'Pa',
          type: 'design',
          values: designValue2
        }
      ]
    },
    getRowDoubleSearch(row, values, property, emptyValue) {
      const highValue = values[envCodes[`${property}High`]] || emptyValue
      const lowValue = values[envCodes[`${property}Low`]] || emptyValue
      return this.$handleDoubleSpeedData(highValue, lowValue)
    },
    // 运行点整理
    getRunTimeProperties(row, isToSelect = false) {
      const emptyValue = isToSelect ? '-' : null
      const isSingleSpeed = this.isSingleSpeed
      return [
        {
          codes: isSingleSpeed ? envCodes.wind : `${envCodes.windHigh}/${envCodes.windLow}`,
          name: '运行风量',
          sort: 1,
          unit: 'm³/h',
          type: 'runtime',
          values: isSingleSpeed ? this.$fmtValue(row.windSelectedRuntime, emptyValue) : this.$handleDoubleSpeedData(this.$fmtValue(row.windHighSelectedRuntime, emptyValue), this.$fmtValue(row.windLowSelectedRuntime, emptyValue))
        },
        {
          codes: isSingleSpeed ? envCodes.pressure : `${envCodes.pressureHigh}/${envCodes.pressureLow}`,
          name: '运行全压',
          sort: 2,
          unit: 'Pa',
          type: 'runtime',
          values: isSingleSpeed ? this.$fmtValue(row.pressureSelectedRuntime, emptyValue) : this.$handleDoubleSpeedData(this.$fmtValue(row.pressureHighSelectedRuntime, emptyValue), this.$fmtValue(row.pressureLowSelectedRuntime, emptyValue))
        },
        {
          codes: isSingleSpeed ? envCodes.efficiency : `${envCodes.efficiencyHigh}/${envCodes.efficiencyLow}`,
          name: '运行全压效率',
          sort: 3,
          unit: '%',
          type: 'runtime',
          values: isSingleSpeed ? this.$fmtValue(row.efficiencySelectedRuntime, emptyValue) : this.$handleDoubleSpeedData(this.$fmtValue(row.efficiencyHighSelectedRuntime, emptyValue), this.$fmtValue(row.efficiencyLowSelectedRuntime, emptyValue))
        }
      ]
    },
    // 产品查询埋点
    async searchTrack(params) {
      const productResult = []
      const brandResult = []
      if (this.tableData && this.tableData.length) {
        this.tableData.forEach((item) => {
          productResult.push({ id: item.id, name: `${item.name}_${item.model}` })
          if (item.brandName && !brandResult.includes(item.brandName)) {
            brandResult.push(item.brandName)
          }
        })
      }
      const curveProperties = this.searchWithCurveProperties ? this.curveProperties.map((c) => {
        return {
          code: c.code,
          value: c.value,
          deviationRate: c.deviationRate,
          unit: c.unit
        }
      }) : null
      const projectInfo = await this.getProjectInfo()
      this.$tracks({
        event: 'productQuery',
        params: {
          g_c_keyword: params.keyword,
          g_c_class_code: params.gjwCategoryCode,
          g_c_class_name: '通风机',
          g_c_property: {
            speedControl: params.speedControl,
            curveProperties: curveProperties,
            productProperties: params.productProperties,
          },
          g_c_brand_code: params.brandCode,
          g_c_product_series: params.productSeriesName,
          g_c_non_filter_condition: {
            page: params.pageNo,
            page_size: params.pageSize,
          },
          g_c_product_result: productResult,
          g_c_brand_result: brandResult,
          g_c_result_count: this.totalCount,
          g_c_default_condition: this.defaultView,
          g_c_project_id: projectInfo.id,
          g_c_project_file_path: projectInfo.path,
          g_c_project_file_name: projectInfo.name
        }
      })
      // 只有第一次进入页面是缺省，再次打点都认为是false
      if (this.defaultView) {
        this.defaultView = false
      }
    },

    updateOrderBy() {
      const prop = this.orderProp
      if (prop && prop !== 'productSeriesName') {
        this.orderBy = this.isSingleSpeed ? envCodes[prop] : envCodes[`${prop}High`]
      }
    },
    onSortChange({ prop, order }) {
      this.pageNo = 1
      if (order) {
        let orderBy
        if (prop !== 'productSeriesName') {
          orderBy = this.isSingleSpeed ? envCodes[prop] : envCodes[`${prop}High`]
        } else {
          orderBy = prop
        }
        this.orderProp = prop
        this.orderBy = orderBy
        this.orderType = order === 'ascending' ? 'ASC' : 'DESC'
      } else {
        this.orderProp = null
        this.orderBy = null
        this.orderType = null
      }
      this.getList({ refreshOrder: false, refreshProperty: true })
    },
    clearCurveFilter() {
      this.$refs.curveSearch.clearData()
      this.searchByCurve([])
    },
    clearDeviationFilter(deviation) {
      this.$refs.curveSearch.clearDeviation(deviation)
      const property = this.curveProperties.find((c) => c.code === deviation.code)
      if (property) { property.deviationRate = null }
      this.search()
    },
    clearProductFilter(product) {
      if (product.code === 'productSeries') {
        this.productSeriesId = null
        this.productSeriesName = null
      }

      this.productProperties = this.productProperties.filter((f) => !(f.code === product.code && f.valueCode === product.valueCode))

      this.$refs.filterSearch.updateSearchForm(product)
      // 重新请求产品列表和筛选条件
      this.search()
    },
    clearAllFilters() {
      this.$refs.curveSearch.clearData()
      this.curveProperties = []
      this.productProperties = []
      this.productSeriesId = null
      this.productSeriesName = null
      this.$refs.filterSearch.resetSearchForm()
      this.search()
    },
    onSpeedChanged() {
      this.clearAllFilters()
    },
    /** 处理筛选逻辑 */
    onFilterSelected(select) {
      if (select.code === 'productSeries') {
        this.productSeriesId = select.valueCode
        this.productSeriesName = select.valueName
        this.productProperties = this.productProperties.filter((s) => s.code !== select.code)
        this.productProperties.push(select)
      } else {
        // 数据不为当前选中的大类
        this.productProperties = this.productProperties.filter((s) => select.some((item) => s.code !== item.code))

        if (!(select.length === 1 && select[0].valueCode === null)) {
          select.forEach((v) => {
            this.productProperties.push({ ...v })
          })
        }
      }
      this.search()
    },
    handleShowFilterSearch(val) {
      this.showFilterSearch = val
    }
  }
}
</script>

<style lang="less" scoped>
  .product-list{
    display: flex;
    flex-direction: column;
    padding-bottom: 10px;
    .search-box, .result-row{
      flex: none;
    }
    .table-box{
      flex: 1 1 100px;
      overflow: hidden;
    }
    .empty-list-feedback{
      cursor: pointer;
      font-style: normal;
      font-weight: bold;
      color: @theme-color;
    }
  }
  .search-block{
    position: relative;
    display: flex;
    padding: 6px 0;
    line-height: 28px;
    .label{
      min-width: 56px;
    }
    .switch{
      margin: 4px 16px 4px 0;
    }
  }
  .brand-tag{
    display: inline-block;
    padding: 0 12px;
    cursor: default;
    &:hover{
      color: @theme-hover-color;
    }
    &.active{
      border-radius: 2px;
      color: @white;
      background: @theme-color;
    }
    &.active:hover{
      background: @theme-hover-color;
    }
    &.disabled{
      cursor: not-allowed;
      color: @theme-text-light;
    }
  }
  .result-row{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
  .result{
    height: 26px;
    line-height: 26px;
    margin-left: 12px;
  }
  .feedback-info{
    height: 45px;
    line-height: 45px;
    text-align: center;
    position: relative;
    font-size: 12px;
    &::after{
      position: absolute;
      content: '';
      width: 100%;
      height: 1px;
      bottom: 0;
      left: 0;
      background-color: #ebeef5;
    }
  }
</style>
